import React, { useEffect, useRef, useState } from "react";
import PageTableHeader from "../../../components/pageTableHeader/pageTableHeader";
import DefaultCheckbox from "../../../components/inputs/defaultCheckbox";
import { BiSolidCloudUpload } from "react-icons/bi";
import { TbCircleDotted, TbLayoutGridAdd } from "react-icons/tb";
import DefaultSearchSelectInput from "../../../components/inputs/defaultSearchSelectInput";
import { FaArrowRightLong } from "react-icons/fa6";
import { AiOutlineCheck, AiOutlineInfoCircle } from "react-icons/ai";
import { FaStarOfLife } from "react-icons/fa";
import DefaultButton from "../../../components/buttons/defaultButton";
import { HiDownload } from "react-icons/hi";
import CommonModal from "../../../components/modals/commonModel";
import { IoMdClose, IoMdCloudUpload } from "react-icons/io";
import Papa from 'papaparse';
import toast from "react-hot-toast";
import { MdOutlineReplay } from "react-icons/md";
import { _CasteData, _formatFileSize, _GenderData, _NationalityData, importOptions } from "../../../../utils/common";
import { _fetchFormFields, _ImportByModule } from "../../../../store/actions/global";
import { _FORM_MODULES, dateFormat } from "../../../../utils/helper";
import { useDispatch, useSelector } from "react-redux";
import { _fetchDepartments, _fetchDesignations } from "../../../../store/actions/configuration";
// Note: _fetchClasses import removed as class functionality is not available for HR management system
import { _setUploadFiles } from "../../../../store/slices/global.slice";
import { v4 as uuidv4 } from 'uuid';
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { fileSampleByModule } from "../../../../services/workspace/global.service";
import * as XLSX from 'xlsx';
import { checkValidCasteCategory, checkValidGender, checkValidNationality, checkValidReligion, convertDateToYYYYMMDD, validateEmail, isValidDate } from "../../../../utils/importHelper";
import { exportUser, getUserImportFormFields, userSample } from "../../../../services/workspace/user.service";
import { useExport } from "../../../../hooks";

const items = [
    { label: "Staff Directory", path: "/hr/staff-directory" },
    { label: "Import" },
];

const convertExcelDate = (serial) => {
    if (!serial || isNaN(serial)) return serial; // Return null if invalid

    const excelStartDate = new Date(1899, 11, 30); // Excel's base date (Dec 30, 1899)
    const convertedDate = new Date(excelStartDate.getTime() + serial * 86400000);

    // Ensure the date matches the expected format
    const year = convertedDate.getFullYear();
    const month = String(convertedDate.getMonth() + 1).padStart(2, "0"); // Adjust for 0-based month
    const day = String(convertedDate.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`; // Return YYYY-MM-DD
};

const cleanRow = (row) => {
    const cleanedRow = {};

    // Iterate over each key in the row
    Object.keys(row).forEach((key) => {
        if (!key.startsWith("__EMPTY")) { // Remove empty columns
            cleanedRow[key] = row[key];
        }
    });

    // Convert date fields
    if (cleanedRow.dob) {
        cleanedRow.dob = convertExcelDate(cleanedRow.dob);
    }
    if (cleanedRow.joining_at) {
        cleanedRow.joining_at = convertExcelDate(cleanedRow.joining_at);
    }

    return cleanedRow;
};

const ImportStaff = () => {
    const [file, setFile] = useState(null);
    const [override, setOverride] = useState(false);
    const [isDragging, setIsDragging] = useState(false);
    const [formFileds, setFormFileds] = useState([]);
    const [steps, setSteps] = useState(0);
    const dispatch = useDispatch();
    const [rowData, setRowData] = useState([]);
    const [failedRecordsData, setFailedRecordsData] = useState([]);
    const [validRecordsData, setValidRecordsData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const { departments, designations } = useSelector((state) => state.configuration);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isDownloading, setIsDownloading] = useState(false);
    const [activeUnit, setActiveUnit] = useState("long");
    const { exportToExcel } = useExport();

    useEffect(() => {
        dispatch(_fetchDepartments());
        dispatch(_fetchDesignations());
      }, []);

    const callback = (error = false, response = []) => {
        if (error) {
            toast.error("Something went wrong. Please try again.1");
            return;
        }
        const formatedValues = response.map((item) => {
            return {
                ...item,
                value: null,
                match: false
            }
        })
        setFormFileds([...formatedValues]);
    };

   const getStudentImportFormFields = () => {
    getUserImportFormFields({ type: 2 })
    .then((response) => {
        setFormFileds(response)
    })
   }

    useEffect(() => {
        // call feat api 
        getStudentImportFormFields()
      
    }, [activeUnit])

    useEffect(() => {
        // dispatch(_fetchClasses())
        return () => {
            setSteps(0);
            setRowData([]);
            setFormFileds([]);
            setFile(null);
            setValidRecordsData([]);
            setFailedRecordsData([]);
            setIsSubmitting(false);
            setIsLoading(false);
            setOverride(false);
        }
    }, []);

    const resetFormFields = () => {
        setFormFileds([])
        getStudentImportFormFields()
        setRowData([]);
        setFailedRecordsData([]);
        setValidRecordsData([]);
    }

    const handleDragEnter = (e) => {
        e.preventDefault();
        setIsDragging(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        setIsDragging(false);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);

        const files = e.dataTransfer.files || [];

        if (files) {
            handleFileUpload(files);
        }
    };

    const handleFileChange = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const files = e.target?.files || [];
        if (files) {
            handleFileUpload(files);
        }
    };

    // const checkUserByClassAndSection = (userClass = "", userSection = "") => {
    //     // Ensure `classes` array is provided
    //     if (!Array.isArray(classes) || classes.length === 0) {
    //         return { isValid: false, error: "Classes data is empty or not provided" };
    //     }

    //     // Trim spaces and convert to lowercase for case-insensitive matching
    //     const trimmedUserClass = userClass.trim().toLowerCase();
    //     const trimmedUserSection = userSection.trim().toLowerCase();

    //     // Find the class in the `classes` array (case-insensitive)
    //     const classMatch = classes.find(
    //         (cls) => cls.name.trim().toLowerCase() === trimmedUserClass
    //     );

    //     if (!classMatch) {
    //         return { isValid: false, error: `Class '${userClass}' not found in the system.` };
    //     }

    //     // Check for the section in the matched class (case-insensitive)
    //     const sectionMatch = classMatch.sections.find(
    //         (sec) => sec.name.trim().toLowerCase() === trimmedUserSection
    //     );

    //     if (!sectionMatch) {
    //         return { isValid: false, error: `Section '${userSection}' not found in Class '${userClass}'.` };
    //     }

    //     // If both class and section exist
    //     return { isValid: true, classId: classMatch.id, sectionId: sectionMatch.id };
    // };
    

    const checkValidDOB = (dob) => {
        // Ensure dob is provided and is a string
        if (!dob || typeof dob !== "string") {
            return { isValid: false, error: "Date of Birth (DOB) is not provided or invalid." };
        }

        // Use the existing isValidDate function from importHelper
        const { isValid, error } = isValidDate(dob);
        if (!isValid) {
            return { isValid: false, error };
        }

        // Convert DOB string to a Date object for age validation (YYYY-MM-DD format)
        const [year, month, day] = dob.split("-").map(Number);
        const dobDate = new Date(year, month - 1, day); // JS months are 0-based

        // Check if the parsed date is valid
        if (
            isNaN(dobDate.getTime()) ||
            dobDate.getFullYear() !== year ||
            dobDate.getMonth() !== month - 1 ||
            dobDate.getDate() !== day
        ) {
            return { isValid: false, error: "DOB is not a valid date." };
        }

        // Check minimum age (18 years for staff)
        const minEligibleDate = new Date(dobDate);
        minEligibleDate.setFullYear(minEligibleDate.getFullYear() + 18);

        const today = new Date();
        if (today < minEligibleDate) {
            return { isValid: false, error: "Age must be at least 18 years for staff." };
        }

        return { isValid: true };
    };

    const checkValidDate = (date) => {
        // Ensure dob is provided and is a string
        if (!date || typeof date !== "string") {
            return { isValid: false, error: "Date is not provided or invalid." };
        }

        // Use the existing isValidDate function from importHelper
        const { isValid, error } = isValidDate(date);
        if (!isValid) {
            return { isValid: false, error };
        }

        // Convert date string to a Date object for validation (YYYY-MM-DD format)
        const [year, month, day] = date.split("-").map(Number);
        const dateDate = new Date(year, month - 1, day); // JS months are 0-based

        // Check if the parsed date is valid
        if (
            isNaN(dateDate.getTime()) ||
            dateDate.getFullYear() !== year ||
            dateDate.getMonth() !== month - 1 ||
            dateDate.getDate() !== day
        ) {
            return { isValid: false, error: "Date is not a valid date." };
        }

        return { isValid: true };
    };

    const getDepartmentId = (departmentName, departmentsList = departments) => {
        if (!Array.isArray(departmentsList) || departmentsList.length === 0) {
            return null;
        }
        
        const departmentMatch = departmentsList.find(
            (dep) => {
                if (!dep || !dep.name || typeof dep.name !== 'string') {
                    return false;
                }
                return dep.name.trim().toLowerCase() === departmentName.trim().toLowerCase();
            }
        );
        
        return departmentMatch ? { id: departmentMatch.id, uuid: departmentMatch.uuid } : null;
    };

    const getDesignationId = (designationName, departmentName, designationsList = designations) => {
        if (!Array.isArray(designationsList) || designationsList.length === 0) {
            return null;
        }
        
        const departmentInfo = getDepartmentId(departmentName);
        if (!departmentInfo) {
            return null;
        }
        
        const designationMatch = designationsList.find(
            (des) => {
                if (!des || !des.name || typeof des.name !== 'string') {
                    return false;
                }
                return des.name.trim().toLowerCase() === designationName.trim().toLowerCase() && 
                       departmentInfo.uuid === des.department;
            }
        );
        
        return designationMatch ? { id: designationMatch.id } : null;
    };

    const checkDepartment = (department, departmentsList = departments) => {
      
        // Safety check: ensure departments array exists and is not empty
        if (!Array.isArray(departmentsList) || departmentsList.length === 0) {
            return { isValid: false, error: "Department data is not loaded yet. Please try again." };
        }
        
        // Safety check: ensure department parameter is valid
        if (!department || typeof department !== 'string') {
            return { isValid: false, error: "Department name is required and must be a valid string." };
        }
            
        const departmentMatch = departmentsList.find(
            (dep) => {
                // Safety check: ensure dep and dep.name exist and are strings
                if (!dep || !dep.name || typeof dep.name !== 'string') {
                    return false;
                }
                return dep.name.trim().toLowerCase() === department.trim().toLowerCase();
            }
        );
        if (!departmentMatch) {
            return { isValid: false, error: `Department '${department}' not found in the system.` };
        }
        return { isValid: true, departmentId: departmentMatch.id }; 
    }

  const checkDesignation = (designation,department, designationsList = designations,departmentsList = departments) => {
    if (!department || typeof department !== 'string') {
        return { isValid: false, error: "Department name is required and must be a valid string." };
    }
   const departmentUuid = getDepartmentId(department) 
    

    if (!Array.isArray(designationsList) || designationsList.length === 0) {
      return { isValid: false, error: "Designation data is not loaded yet. Please try again." };
    }
    if (!designation || typeof designation !== 'string') {
      return { isValid: false, error: "Designation name is required and must be a valid string." };
    }
    const designationMatch = designationsList.find(
      (des) => {
        if (!des || !des.name || typeof des.name !== 'string' ) {
          return false;
        }
        return des.name.trim().toLowerCase() === designation.trim().toLowerCase() && departmentUuid?.uuid === des.department
      
      }
    );
     if (!designationMatch) {
       return { isValid: false, error: `Designation '${designation}' not found in the system.` };
     }
    return { isValid: true, designationId: designationMatch.id };
  }

    const checkPhoneNumbers = (data, formFields) => {
        const errors = [];

        // Map fields from formFileds
        const fields = ["phone", "parent_contact"].map(
            (key) => ({ key, value: formFields.find((field) => field.column === key)?.value || formFields.find((field) => field.column === key)?.column })
        ).filter(({ value }) => Boolean(value)); // Skip undefined values

        fields.forEach(({ key, value }) => {
            let phoneNumber = data[value]?.toString().trim();

            // Skip validation if it's 'parent_contact' and empty
            if (key === "parent_contact" && !phoneNumber) {
                return;
            }

            if (!phoneNumber) {
                errors.push(`${value} is not provided or invalid.`);
                return;
            }

            if (!/^\d+$/.test(phoneNumber)) {
                errors.push(`${value} must contain only numeric characters.`);
                return;
            }

            if (phoneNumber.length < 10) {
                errors.push(`${value} must be at least 10 characters long.`);
                return;
            }

            if (phoneNumber.length > 15) {
                errors.push(`${value} must not exceed 15 characters.`);
            }
        });

        return errors.length === 0
            ? { isValid: true }
            : { isValid: false, error: errors.join(" ") };
    };

    const processCSVRecords = (filteredData, skipValidation = false) => {
        // Check if formFileds are available and properly mapped
        if (!formFileds || formFileds.length === 0) {
            return { validRecords: [], failedRecords: [] };
        }

        // If skipValidation is true, just return the data without validation
        if (skipValidation) {
            return { validRecords: filteredData, failedRecords: [] };
        }

        // Check if all required fields are mapped
        const unmappedRequiredFields = formFileds
            .filter(field => field.required && (!field.value || !field.match))
            .map(field => field.column);
        
        if (unmappedRequiredFields.length > 0) {
            return { validRecords: [], failedRecords: [] };
        }

        // Check if departments are loaded before processing
        if (!Array.isArray(departments) || departments.length === 0) {
            toast.error("Department data is still loading. Please wait a moment and try again.");
            return { validRecords: [], failedRecords: [] };
        }

        setFailedRecordsData([]);
        setValidRecordsData([]);

        const requiredFields = formFileds
            .filter((item) => item.required)
            .map((item) => item.value || item?.column);

        const getFieldValue = (col) => {
            const field = formFileds.find((f) => f.column === col);
            
            // Only return the mapped value if the field is actually mapped
            if (field && field.value && field.match) {
                return field.value;
            }
            
            // If field exists but not mapped, return undefined
            if (field && !field.value) {
                return undefined;
            }
            
            return field?.column;
        };
        const seenAadhaarAndPhone = new Set();
        const validRecords = [];
        const tempFailedRecords = [];

        for (const [index, data] of filteredData.entries()) {
            const rowNumber = index + 2;
            const errorMessages = [];

            // 1. Check for missing required fields
            const missingFields = requiredFields.filter((field) => !data[field]);
            if (missingFields.length > 0) {
                errorMessages.push(
                    `<span style="color: black;display: flex;flex-direction: column;gap: 20px;">
                    The following fields are missing: 
                    <span style="font-weight: bold; color: #FF0000; display: flex; flex-direction: column; gap: 10px;">
                        ${missingFields.join("</br>")}
                    </span> 
                    Please check
                </span>`
                );
            }

            // 2. Email validation
            const emailField = getFieldValue("email");
            if (emailField && data[emailField] && !validateEmail(data[emailField])) {
                errorMessages.push(`<span style="font-weight: bold; color: #FF0000;">Invalid Email Format: Please check the email address.</span><br/>`);
            }

            // // 3. Aadhaar validation
            // const aadharCardField = getFieldValue("aadhar_card");
            // const aadharValue = data[aadharCardField];
            // if (!/^\d{4}$/.test(aadharValue)) {
            //     errorMessages.push(`<span style="font-weight: bold; color: #FF0000;">Invalid Aadhaar Card Number: Must contain at least 4 digits.</span><br/>`);
            // }

            // 4. Phone validation
            const { isValid: isPhoneValid, error: phoneError } = checkPhoneNumbers(data, formFileds);
            if (!isPhoneValid) {
                errorMessages.push(`<span style="font-weight: bold; color: #FF0000;">${phoneError}</span><br/>`);
            }

            // 3. Department validation
            const departmentField = getFieldValue("department");
            const departmentIdField = getFieldValue("department_id");
            
            if (departmentField && data[departmentField]) {
                const { isValid: isDepartmentValid, error: departmentError } = checkDepartment(data[departmentField]);
                if (!isDepartmentValid) {
                    errorMessages.push(`<span style="font-weight: bold; color: #FF0000;">${departmentError}</span><br/>`);
                }
            } else if (departmentIdField && data[departmentIdField]) {
                // If department_id field is mapped, validate it as department name
                const { isValid: isDepartmentValid, error: departmentError } = checkDepartment(data[departmentIdField]);
                if (!isDepartmentValid) {
                    errorMessages.push(`<span style="font-weight: bold; color: #FF0000;">${departmentError}</span><br/>`);
                }
            }

            // 4. Designation validation
            const designationField = getFieldValue("designation");
            const designationIdField = getFieldValue("designation_id");
            
            if (designationField && data[designationField]) {
                const { isValid: isDesignationValid, error: designationError } = checkDesignation(data[designationField], data[departmentField]);
                if (!isDesignationValid) {
                    errorMessages.push(`<span style="font-weight: bold; color: #FF0000;">${designationError}</span><br/>`);
                }
            } else if (designationIdField && data[designationIdField]) {
                // If designation_id field is mapped, validate it as designation name
                const deptField = departmentField || departmentIdField;
                const deptValue = deptField ? data[deptField] : null;
                const { isValid: isDesignationValid, error: designationError } = checkDesignation(data[designationIdField], deptValue);
                if (!isDesignationValid) {
                    errorMessages.push(`<span style="font-weight: bold; color: #FF0000;">${designationError}</span><br/>`);
                }
            }

            // // 5. Duplicate Aadhaar + Phone check
            // const phoneField = getFieldValue("phone");
            // const uniqueKey = `${aadharValue}_${data[phoneField]}`;
            // if (seenAadhaarAndPhone.has(uniqueKey)) {
            //     errorMessages.push(`<span style="font-weight: bold; color: #FF0000;">Duplicate Entry: Aadhaar and Phone number combination already exists.</span><br/>`);
            // } else {
            //     seenAadhaarAndPhone.add(uniqueKey);
            // }

            // // 6. Class + Section validation
            // const classField = getFieldValue("class");
            // const sectionField = getFieldValue("section");
            // const { isValid, error } = checkUserByClassAndSection(data[classField], data[sectionField]);
            // if (!isValid) {
            //     errorMessages.push(`<span style="font-weight: bold; color: #FF0000;">${error}</span><br/>`);
            // }

            // 5. Gender validation
            const genderField = getFieldValue("gender");
            if (genderField && data[genderField]) {
                const { isValid: isGenderValid, error: genderError } = checkValidGender(data[genderField]);
                if (!isGenderValid) {
                    errorMessages.push(`<span style="font-weight: bold; color: #FF0000;">${genderError}</span><br/>`);
                }
            }

            // // 8. Optional: Religion
            // const religionField = getFieldValue("religion");
            // if (data[religionField]) {
            //     const { isValid: isReligionValid, error: religionError } = checkValidReligion(data[religionField]);
            //     if (!isReligionValid) {
            //         errorMessages.push(`<span style="font-weight: bold; color: #FF0000;">${religionError}</span><br/>`);
            //     }
            // }

            // // 9. Optional: Caste Category
            // const casteField = getFieldValue("caste_category");
            // if (data[casteField]) {
            //     const { isValid: isCasteValid, error: casteError } = checkValidCasteCategory(data[casteField]);
            //     if (!isCasteValid) {
            //         errorMessages.push(`<span style="font-weight: bold; color: #FF0000;">${casteError}</span><br/>`);
            //     }
            // }

            // // 10. Optional: Nationality
            // const nationalityField = getFieldValue("nationality");
            // if (data[nationalityField]) {
            //     const { isValid: isNationalityValid, error: nationalityError } = checkValidNationality(data[nationalityField]);
            //     if (!isNationalityValid) {
            //         errorMessages.push(`<span style="font-weight: bold; color: #FF0000;">${nationalityError}</span><br/>`);
            //     }
            // }

            // 6. DOB validation
            const dobField = getFieldValue("dob");
            if (dobField && data[dobField]) {
                const { isValid: isDOBValid, error: dobError } = checkValidDOB(data[dobField]);
                if (!isDOBValid) {
                    // Make error message specific for DOB
                    const specificError = dobError.startsWith("DOB") || dobError.startsWith("Date of Birth") 
                        ? dobError 
                        : `DOB: ${dobError}`;
                    errorMessages.push(`<span style="font-weight: bold; color: #FF0000;">${specificError}</span><br/>`);
                }
            }

            // 7. Joining Date validation
            const joiningDateField = getFieldValue("joining_at");
            if (joiningDateField && data[joiningDateField]) {
                const { isValid: isJoiningDateValid, error: joiningDateError } = checkValidDate(data[joiningDateField]);
                if (!isJoiningDateValid) {
                    // Make error message specific for Joining Date
                    const specificError = joiningDateError.startsWith("Joining Date") || joiningDateError.startsWith("Joining")
                        ? joiningDateError 
                        : `Joining Date: ${joiningDateError}`;
                    errorMessages.push(`<span style="font-weight: bold; color: #FF0000;">${specificError}</span><br/>`);
                }
            }

            // 8. Check if joining date is at least 18 years after DOB
            const dobFieldValue = dobField && data[dobField] ? data[dobField] : null;
            const joiningDateValue = joiningDateField && data[joiningDateField] ? data[joiningDateField] : null;
            
            if (dobFieldValue && joiningDateValue) {
                // Parse both dates
                const [dobYear, dobMonth, dobDay] = dobFieldValue.split("-").map(Number);
                const [joiningYear, joiningMonth, joiningDay] = joiningDateValue.split("-").map(Number);
                
                const dobDate = new Date(dobYear, dobMonth - 1, dobDay);
                const joiningDate = new Date(joiningYear, joiningMonth - 1, joiningDay);
                
                // Check if dates are valid
                if (!isNaN(dobDate.getTime()) && !isNaN(joiningDate.getTime())) {
                    // Calculate the minimum eligible joining date (18 years after DOB)
                    const minEligibleJoiningDate = new Date(dobDate);
                    minEligibleJoiningDate.setFullYear(minEligibleJoiningDate.getFullYear() + 18);
                    
                    // Check if joining date is before the minimum eligible date
                    if (joiningDate < minEligibleJoiningDate) {
                        errorMessages.push(`<span style="font-weight: bold; color: #FF0000;">Joining date must be at least 18 years after the date of birth.</span><br/>`);
                    }
                }
            }

            // 9. Parent Email validation (optional)
            const parentEmailField = getFieldValue("parent_email");
            if (parentEmailField && data[parentEmailField]) {
                const emailValue = data[parentEmailField].toString().trim();
                if (!validateEmail(emailValue)) {
                    errorMessages.push(
                        `<span style="font-weight: bold; color: #FF0000;">Parent Email Address is invalid: "${emailValue}" is not a valid email address.</span><br/>`
                    );
                }
            }

            // Record as failed if there are any errors
            if (errorMessages.length > 0) {
                tempFailedRecords.push({
                    ...data,
                    record: rowNumber,
                    message: errorMessages.join(""),
                });
            } else {
                validRecords.push({ ...data });
            }
        }
        setFailedRecordsData(tempFailedRecords);
        setValidRecordsData(validRecords);

        return {
            validRecords,
            failedRecords: tempFailedRecords.length,
        };
    };

    const processFileData = (data) => {
        const filteredData = data.filter(item =>
            Object.values(item).some(value => value?.toString().trim() !== "")
        );

        if (filteredData.length === 0) {
            toast.error("Please select a valid file containing at least one record.");
            return;
        }

        setRowData(filteredData);

        if (filteredData.length > 0) {
            setIsLoading(true);
            // Skip validation during initial file processing - validation will happen after field mapping
            const { validRecords } = processCSVRecords(filteredData, true);
            setValidRecordsData(validRecords);
            setIsLoading(false);
        }
    };

    const handleFileUpload = (files) => {
        resetFormFields();
        setSteps(0);
        const file = files[0];

        if (!file) return; // If no file is selected

        const allowedTypes = [
            'text/csv',
            'application/vnd.ms-excel', // .xls
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' // .xlsx
        ];

        // Check file type
        if (!allowedTypes.includes(file.type)) {
            toast.error('Unsupported file format. Please upload a CSV or Excel file.');
            return;
        }

        setFile(file);

        if (file.type === 'text/csv') {
            Papa.parse(file, {
                header: true,
                skipEmptyLines: true,
                complete: (results) => {
                    processFileData(results.data);
                }
            });
        } else {
            const reader = new FileReader();
            reader.onload = (e) => {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
                const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: '' });

                const cleanedData = jsonData.map(cleanRow);

                processFileData(cleanedData);
            };
            reader.readAsArrayBuffer(file);
        }
    };

    const resetFiles = () => {
        resetFormFields()
        setSteps(0);
        setFile(null);
    }

    const handleCheckbox = (value) => {
        setOverride(value)
    }

    const updateFormfields = (name) => {
        setFormFileds((prevFields) => {
            // Check if update is actually needed
            const isUpdated = prevFields.some((item) => item.column === name && !item.match);
            if (isUpdated) {
                // Map through previous fields to update only the necessary item
                return prevFields.map((item) => {
                    if (item.column === name) {
                        return { ...item, match: true, value: name };
                    }
                    return item;
                });
            }
            // Return previous state if no update is needed
            return prevFields;
        });
    };

    const toggleSteps = (state = 0) => {
        const isMissMatch = formFileds.find((item) => !item?.match)
        if (isMissMatch) {
            toast.error("Please map all the fields to proceed. Check and try again!")
        } else {
            setIsLoading(true);
            // Only process records if we have rowData and formFileds are properly mapped
            if (rowData && rowData.length > 0 && formFileds && formFileds.length > 0) {
                const { validRecords } = processCSVRecords(rowData)
                setValidRecordsData(validRecords); // Update state with valid records
            }
            setTimeout(() => {
                setIsLoading(false);
            }, 500);
            setSteps(state)
        }
    }

    const handleDropdownChange = (dropdownValue, dropdownItem) => {
        setFormFileds((prevFields) => {
            return prevFields.map((field) => {
                if (field.column === dropdownItem?.column) {
                    return {
                        ...field,
                        match: true,
                        value: dropdownValue?.value,
                    };
                }
                return field;
            });
        });
    };

    const downloadErrorMessages = () => {
        const htmlMessages = failedRecordsData
            .map(
                (error) => `
              <div style="display:flex; flex-direction: column; gap:10px; border: 1px solid #FF0000;background: #fafafa; border-radius: 10px; padding: 10px;">
                <strong>Record/Row ${error.record} :</strong> ${error.message}
              </div>
            `
            )
            .join("");

        const htmlContent = `
              <!DOCTYPE html>
              <html lang="en">
              <head>
                <meta charset="UTF-8">
                <meta name="viewport" content="width=device-width, initial-scale=1.0">
                <title>Error Messages</title>
              </head>
              <body>
              <div style="color: black; text-align:center; font-weight: bold; padding:5px;">${file?.name || "Unknown file"
            }</div>
              <div style="color: black; text-align:center; font-size:12px;">(Error Logs)</div>
              <div style="color: black; text-align:start; font-weight: bold; font-size:14px; padding : 0px 12px;">
              ( Total Affected Rows: ${failedRecordsData?.length} )
              </div>
                <div style="color: black; padding: 10px; display:flex; flex-direction: column; gap:10px;">${htmlMessages}</div>
              </body>
              </html>
            `;

        const blob = new Blob([htmlContent], { type: "text/html" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "error-messages.html";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    };

    const navigate = useNavigate();

    const _callback = (error = false, response = []) => {
        setIsSubmitting(false)
        if (error) {
            toast.error("Failed to import the file. Please try again.");
            return;
        }
        toast.success("File imported successfully");
        navigate("/hr/staff-directory");
    };

    const _formatImportPayload = (data, formData) => {
        return data.map((student) => {
            let formattedStudent = {};

            formData.forEach(({ column, value }) => {
                const rawValue = student[value];

                switch (column) {
                    case "department":
                        // Convert department name to department_id
                        const departmentInfo = getDepartmentId(rawValue);
                        if (departmentInfo) {
                            formattedStudent["department_id"] = departmentInfo.id;
                        }
                        break;

                    case "designation":
                        // Convert designation name to designation_id
                        // Find department field from formData
                        const departmentField = formData.find(f => f.column === "department");
                        const departmentName = departmentField ? student[departmentField.value] : null;
                        const designationInfo = getDesignationId(rawValue, departmentName);
                        if (designationInfo) {
                            formattedStudent["designation_id"] = designationInfo.id;
                        }
                        break;

                    case "department_id":
                        // Handle case where CSV already has department_id field with string values
                        const departmentInfoFromId = getDepartmentId(rawValue);
                        if (departmentInfoFromId) {
                            formattedStudent["department_id"] = departmentInfoFromId.id;
                        } else {
                            // If it's already a numeric ID, keep it as is
                            formattedStudent["department_id"] = rawValue;
                        }
                        break;

                    case "designation_id":
                        // Handle case where CSV already has designation_id field with string values
                        // We need to find the department name to get the correct designation
                        const deptField = formData.find(f => f.column === "department");
                        const deptName = deptField ? student[deptField.value] : null;
                        
                        // If we have department name, use it to find designation
                        if (deptName) {
                            const designationInfoFromId = getDesignationId(rawValue, deptName);
                            if (designationInfoFromId) {
                                formattedStudent["designation_id"] = designationInfoFromId.id;
                            } else {
                                formattedStudent["designation_id"] = rawValue;
                            }
                        } else {
                            // If no department name, try to find designation by name only
                            const designationMatch = designations.find(des => 
                                des.name && des.name.toLowerCase() === rawValue.toLowerCase()
                            );
                            if (designationMatch) {
                                formattedStudent["designation_id"] = designationMatch.id;
                            } else {
                                formattedStudent["designation_id"] = rawValue;
                            }
                        }
                        break;

                    case "gender":
                    case "caste":
                    case "religion":
                    case "caste_category":
                    case "nationality":
                        formattedStudent[column] = rawValue ? rawValue.toLowerCase() : "";
                        break;

                    default:
                        // Only assign if not already set (like class_id/section_id)
                        formattedStudent[column] = student.hasOwnProperty(value) ? rawValue : null;
                        break;
                }
            });

            return formattedStudent;
        });
    };

    const handleSubmitFile = async () => {
        // setIsSubmitting(true);

        // Preparing file data for submission
        // Add params with type=2 to fileData for further usage if needed
        const fileData = {
            uuid: uuidv4(),
            name: file.name,
            size: file.size,
            type: file.type,
            success: false,
            failed: true,
            loading: true,
            url: "/user/import",
            params: { type: 2 } // Add params object with type=2
        };

        try {
            // Format the payload for import
            const formattedPayload = _formatImportPayload(rowData, formFileds);
            const final_payload = formattedPayload.map((item) => {
                // const { classId, sectionId } = checkUserByClassAndSection(item?.class, item?.section)
                return { ...item, dob: item?.dob }
                // return { ...item, class_id: classId, section_id: sectionId, dob: convertDateToYYYYMMDD(item?.dob) }
            })
            const payload = {
                data: final_payload,
                is_override: override?1:0,
                type: '2'
            };

            dispatch(_ImportByModule(_FORM_MODULES.STAFF, payload, fileData, _callback));
        } catch (error) {
            dispatch(_setUploadFiles({
                ...fileData,
                loading: false,
                failed: true,
            }));
            toast.error("Failed to process the file. Please try again.");
        }
    };

    useEffect(() => {
        if (formFileds && formFileds?.length && rowData && rowData.length > 0) {
            setIsLoading(true);
            // Skip validation during initial formFileds load - validation will happen after field mapping
            const { validRecords } = processCSVRecords(rowData, true)
            setValidRecordsData(validRecords); // Update state with valid records
            setTimeout(() => {
                setIsLoading(false);
            }, 500);
        }
    }, [formFileds])

    const handleSampleDownload = async () => {
      try {
        await exportToExcel(
          userSample,
          { type: 2 },
          "Staff import sample"
        );
      } catch (error) {
        console.error("Sample download failed:", error);
      }
        
        // setIsDownloading(true)
        // try {
        //     const result = await fileSampleByModule(_FORM_MODULES.STUDENT, { type: activeUnit });
        //     if (result) {
        //         setIsDownloading(false)

        //         window.location.href = result;
        //     } else {
        //         setIsDownloading(false)

        //         toast.error("File download failed!");
        //     }
        // } catch (error) {
        //     setIsDownloading(false)

        //     toast.error("File download failed!");
        // }
    };

    return (
        <div className={"flex flex-col gap-2"}>
            <PageTableHeader
                breadcrumbs={items}
                isSearch={false}
                isFilter={false}
                buttons={false}
            />
            {/* <div className="flex items-center gap-2">
                <ToggleSwitch
                    options={[...importOptions]}
                    activeOption={activeUnit}
                    onSwitch={(val) => {
                        resetFiles();
                        setActiveUnit(val);
                    }}
                />
                {activeUnit == "short" ? <span className="text-yellow-600">
                    Quick Import includes only the essential fields for a faster and simpler setup.
                </span> :
                    <span className="text-yellow-600">
                        Full Import allows you to import all available data fields for a complete setup.
                    </span>}
            </div> */}

            <div className="grid grid-cols-2 bg-white p-4">
                <div className="col-span-2 text-sm text-gray-600 bg-gray-100 p-2 rounded-md my-2">
                    <strong>Note : </strong> Dates must be formatted as <span className="font-semibold">YYYY-MM-DD (e.g., 2001-01-30)</span> when included in the file to ensure accuracy and consistency.
                </div>

                <div>
                    <FileUploadInput
                        files={file}
                        handleFileChange={handleFileChange}
                        handleDragEnter={handleDragEnter}
                        handleDragOver={handleDragOver}
                        handleDragLeave={handleDragLeave}
                        handleDrop={handleDrop}
                        handleSampleDownload={handleSampleDownload}
                        isDownloading={isDownloading}
                        isDragging={isDragging}
                        resetFiles={resetFiles}
                        checkboxValue={override}
                        handleCheckbox={handleCheckbox}
                    />

                    {file && rowData?.length && steps == 0 ?
                        <MapFields
                            updateFormfields={updateFormfields}
                            rowData={rowData}
                            data={formFileds}
                            loading={isLoading}
                            handleDropdownChange={handleDropdownChange}
                            toggleSteps={toggleSteps}
                        /> : null}
                </div>
            </div>

            {/* upload complete */}
            {steps == 1 && rowData && rowData?.length ?
                <ErrorValidate
                    isSubmitting={isSubmitting}
                    handleSubmitFile={handleSubmitFile}
                    file={file}
                    formFileds={formFileds}
                    downloadErrorMessages={downloadErrorMessages}
                    validRecords={validRecordsData}
                    failedRecordsData={failedRecordsData}
                    rowData={rowData}
                    toggleSteps={toggleSteps} />
                : null}
        </div>
    );
};

const ErrorValidate = ({
    toggleSteps = () => null,
    validRecords = [],
    rowData = [],
    formFileds = [],
    file = null,
    failedRecordsData = [],
    isSubmitting = false,
    downloadErrorMessages = () => null,
    handleSubmitFile = () => null
}) => {
    const [confirmModel, setConfirmModel] = useState(false);

    const rowDetails = [
        { label: "Total Rows", value: rowData?.length, status: "total" },
        { label: "Valid Rows", value: validRecords?.length, status: "success" },
        { label: "Invalid Rows", value: failedRecordsData?.length, status: "error" },
    ];

    const onUploadClick = () => {
        setConfirmModel(false);
        handleSubmitFile()
    }

    return (
        <div className="grid grid-cols-2 bg-white p-4">
            <div className="text-primary-950 flex flex-col gap-4">
                <p className="font-bold">{file?.name}</p>
                <span className="flex flex-col border-b pb-4">
                    <span className="font-semibold">Rows Details:</span>
                    <span className="flex flex-row justify-between items-center">
                        <span>{rowData?.length} rows . {formFileds?.length} columns</span>
                        {failedRecordsData && failedRecordsData.length ?
                            <span onClick={downloadErrorMessages} className="flex flex-row justify-center items-center text-error-600 cursor-pointer hover:underline ">
                                Error Logs
                                <HiDownload />
                            </span> : null}
                    </span>
                </span>
                <span className="border-b pb-4">
                    {rowDetails.map((item, index) => (
                        <div key={index} className="flex flex-row justify-between">
                            {item.label && (
                                <span className="font-semibold">{item.label}:</span>
                            )}
                            <span className="flex flex-row justify-between items-center">
                                {item.status === "total" && (
                                    <span className="flex flex-row gap-2 items-center text-primary-950 font-bold">
                                        {item.value}
                                    </span>
                                )}
                                {item.status === "success" && (
                                    <span className="flex flex-row gap-2 items-center text-success-600 font-bold">
                                        {item.value}
                                    </span>
                                )}
                                {item.status === "error" && (
                                    <span className="flex flex-row gap-2 items-center text-error-600 font-bold">
                                        {item.value}
                                    </span>
                                )}
                            </span>
                        </div>
                    ))}
                </span>
                <span className="flex flex-col font-bold">
                    <span className="flex flex-row justify-between items-center">
                        <span className="">Total Rows Imported</span>
                        <span className="flex flex-row gap-2 items-center">{validRecords?.length}</span>
                    </span>
                </span>
                <div className="flex flex-row gap-2">
                    <DefaultButton
                        name={"Confirm"}
                        disabled={failedRecordsData?.length || isSubmitting}
                        variant=""
                        loading={isSubmitting}
                        onClick={() => setConfirmModel(true)}
                    />
                    <DefaultButton
                        disabled={isSubmitting}
                        onClick={() => toggleSteps(0)} name={"Back"} variant="secondary" />

                    {confirmModel ? (
                        <CommonModal
                            show={confirmModel}
                            onClose={() => setConfirmModel(false)}
                            modalSize="md"
                        >
                            <div className="text-primary-950 text-center flex flex-col justify-center items-center gap-2">
                                <p className="text-4xl">
                                    <IoMdCloudUpload />
                                </p>
                                <span>
                                    <p className="font-bold">
                                        Are you sure you want to Upload?
                                    </p>
                                    <p>This action cannot be reverted, once done.</p>
                                </span>
                                <span className="flex flex-row gap-2 justify-center items-center">
                                    <DefaultButton
                                        onClick={onUploadClick}
                                        name={"Upload"}
                                        loading={isSubmitting}
                                        variant=""
                                    />
                                    <DefaultButton
                                        name={"Cancel"}
                                        variant="secondary"
                                        onClick={() => setConfirmModel(false)}
                                    />
                                </span>
                            </div>
                        </CommonModal>
                    ) : (
                        ""
                    )}
                </div>
            </div>
        </div>
    )
}

const MapFields = ({ data = [],
    loading = true,
    rowData = [],
    handleDropdownChange = () => null,
    updateFormfields = () => null,
    toggleSteps = () => null
}) => {
    const Fileskeys = rowData && rowData?.length ? Object.keys(rowData[0]) : []
  

    const getFieldValue = (item) => {
        if (Fileskeys.includes(item.value || item.column)) {
            if (!item.match) {
                updateFormfields(item.value || item.column); // Update only if needed
            }
            return {
                label: item.value || item.column,
                value: item.value || item.column,
                ...item,
            };
        } else {
            return "";
        }
    };

    return (
        <div className="mt-4 flex flex-col gap-4">
            <div>
                <p className="text-primary-950 font-bold text-cs">
                    Mapping Fields
                </p>
                <p className="text-primary-600">
                    Ensure columns from your file are mapped correctly to contact
                    properties.
                </p>
            </div>

            <div className="relative">
                <div className="flex flex-col gap-2">
                    <div className="flex flex-row text-primary-950 trxt-cs">
                        <p className="flex-1">Columns in Sample File</p>
                        <p className="w-20"></p>
                        <p className="flex-1">Columns in Your File</p>
                    </div>
                    {data.map((item) => (
                        <div
                            key={item.id}
                            className="flex flex-row justify-between items-center gap-4 mb-2"
                        >
                            <span className="flex flex-row text-primary-950 flex-1 bg-primary-50 rounded-sm h-9 py-2 px-4">
                                <span className="flex flex-row items-center gap-2">
                                    <TbLayoutGridAdd />
                                    {item.column}
                                </span>
                                {item.required && (
                                    <p className="text-error-900 text-[5px]">
                                        <FaStarOfLife />
                                    </p>
                                )}
                            </span>
                            <span className="flex justify-center items-center">
                                <FaArrowRightLong />
                            </span>
                            <span className="flex flex-row items-center gap-2 flex-1">
                                <span className="w-full">
                                    <DefaultSearchSelectInput
                                        value={getFieldValue(item)}
                                        options={Fileskeys.map((item, index) => {
                                            return {
                                                label: item,
                                                value: item,
                                            }
                                        })}
                                        onChange={(value) => handleDropdownChange(value, item)}
                                    />
                                </span>
                                {item?.match ? (
                                    <span className="rounded-full text-white bg-success-600 flex items-center justify-center">
                                        <AiOutlineCheck />
                                    </span>
                                ) : (
                                    <span className="rounded-full text-error-600 flex items-center justify-center">
                                        <AiOutlineInfoCircle />
                                    </span>
                                )}
                            </span>
                        </div>
                    ))}
                </div>

                {loading && (
                    <div className="w-full h-full absolute top-0 backdrop-blur rounded-sm flex justify-center items-center">
                        <span className="text-4xl font-bold text-primary-950 ">
                            <TbCircleDotted />
                        </span>
                    </div>
                )}
            </div>

            <div className="flex flex-row flex-wrap items-center gap-2">
                <DefaultButton
                    name="Proceed"
                    variant="primary"
                    onClick={() => toggleSteps(1)}
                />
                <DefaultButton name="Cancel" variant="secondary" />
            </div>
        </div>
    )
}

export const ToggleSwitch = ({ options = [], activeOption, onSwitch }) => {
    return (
        <div className="w-fit p-[3px] rounded-full bg-gray-200 flex shadow-inner">
            {options.map((opt) => (
                <button
                    key={opt}
                    onClick={() => onSwitch(opt.value)}
                    className={`px-4 py-2 text-sm font-medium rounded-full transition-all duration-200 ${activeOption === opt.value
                        ? "bg-white shadow text-gray-900"
                        : "bg-transparent text-gray-500"
                        }`}
                >
                    {opt.name}
                </button>
            ))}
        </div>
    );
};

const FileUploadInput = ({
    label = "",
    placeholder = "",
    checkboxValue = false,
    accept = ".csv, .xls, .xlsx",
    isDragging = false,
    heading = "Import File",
    files = null,
    handleDragOver = () => null,
    handleDragLeave = () => null,
    handleDragEnter = () => null,
    handleDrop = () => null,
    handleFileChange = () => null,
    handleCheckbox = () => null,
    handleSampleDownload = () => null,
    resetFiles = () => null,
    isDownloading = false
}) => {
    const fileRef = useRef(null);

    const handleReUpload = () => {
        if (fileRef.current) {
            fileRef.current.click();
        } else {
            toast.error("Reupload failed. Please try again!");
        }
    };

    return (
        <div>
            <p className="text-primary-950 font-bold text-cs mb-2">{heading}</p>
            {files ?
                <div
                    className={`border border-dashed rounded-lg p-4 border-primary-950 bg-primary-50 hover:bg-primary-100 min-h-[120px]
                        flex flex-col justify-end items-center gap-2 relative
                 }`}
                >
                    <input
                        ref={fileRef}
                        type="file"
                        id="fileInput"
                        accept={accept}
                        className="hidden"
                        onChange={handleFileChange}
                        placeholder={placeholder}
                        multiple
                    />

                    <span onClick={resetFiles} className="cursor-pointer absolute right-2 top-2 text-xl">
                        <IoMdClose />
                    </span>

                    <span onClick={handleReUpload} className="cursor-pointer font-medium text-primary-700 flex gap items-center">
                        <MdOutlineReplay />
                        Upload Again
                    </span>

                    <span className="flex-flex-col text-center">
                        <p className="text-primary-950 text-cs">
                            {files?.name || "Unknown file."}
                        </p>
                        <span className="text-primary-600 font-normal leading-3">
                            {_formatFileSize(files.size)}
                        </span>
                        <span className="text-primary-600 font-normal leading-3">
                            { }
                        </span>
                    </span>
                </div>
                :
                <div
                    className={`border border-dashed rounded-lg p-4 min-h-[120px] ${isDragging
                        ? "border-primary-950 bg-success-50 "
                        : "border-primary-950 bg-primary-50 hover:bg-primary-100"
                        }`}
                    onDragEnter={handleDragEnter}
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                    onDrop={handleDrop}
                >
                    {label && (
                        <div className="mb-2">
                            <label className="text-primary-950 font-medium text-sm">
                                {label}
                                <span className="text-red-600 ml-1">*</span>
                            </label>
                        </div>
                    )}
                    <label
                        htmlFor="fileInput"
                        className="cursor-pointer flex justify-center items-center"
                    >
                        <input
                            ref={fileRef}
                            type="file"
                            id="fileInput"
                            accept={accept}
                            className="hidden"
                            onChange={handleFileChange}
                            placeholder={placeholder}
                            multiple
                        />

                        <div className="text-sm flex flex-col gap-2 justify-center items-center">
                            <span className="text-primary-950 text-4xl">
                                <BiSolidCloudUpload />
                            </span>
                            <span className="flex-flex-col">
                                <p className="text-primary-950 text-cs">
                                    Drag and drop or click Browse to upload
                                </p>
                                <span className="text-primary-600 font-normal leading-3">
                                    Ensure your file is in .csv, .xls or .xlsx format
                                </span>
                            </span>
                        </div>
                    </label>
                </div>
            }
            <div className="flex justify-between items-center mt-4">
                <div className="flex items-center gap-2">
                    <DefaultCheckbox
                        id={"override"}
                        name={"override"}
                        label={"Override Duplicate"}
                        value={checkboxValue}
                        onChange={handleCheckbox} />
                </div>
                <button disabled={isDownloading} onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    handleSampleDownload()
                }}
                    className="text-blue-500 text-sm font-medium">
                    Download Sample File
                </button>
            </div>
        </div>
    )
}

export default ImportStaff;

